import { render, staticRenderFns } from "./SafetyAccidentNumberOfStaff.vue?vue&type=template&id=785d0d9e&scoped=true&"
import script from "./SafetyAccidentNumberOfStaff.vue?vue&type=script&lang=js&"
export * from "./SafetyAccidentNumberOfStaff.vue?vue&type=script&lang=js&"
import style0 from "./SafetyAccidentNumberOfStaff.vue?vue&type=style&index=0&id=785d0d9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785d0d9e",
  null
  
)

export default component.exports